/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/BarcodeDocumentTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { GenericDocument } from '../generic_document/GenericDocument';
/** @hidden */
export const BarcodeDocumentFormatValues = [
    'AAMVA',
    'BOARDING_PASS',
    'DE_MEDICAL_PLAN',
    'MEDICAL_CERTIFICATE',
    'ID_CARD_PDF_417',
    'SEPA',
    'SWISS_QR',
    'VCARD',
    'GS1',
    'HIBC',
    'BRITISH_COLUMBIA_DRIVER_LICENSE',
];
/**
Barcode document formats.
*/
export class BarcodeDocumentFormats {
    /** @param source {@displayType `DeepPartial<BarcodeDocumentFormats>`} */
    constructor(source = {}) { }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (BarcodeDocumentFormats) {
    /**
      All barcode document formats.
      */
    BarcodeDocumentFormats.all = [
        'AAMVA',
        'BOARDING_PASS',
        'DE_MEDICAL_PLAN',
        'MEDICAL_CERTIFICATE',
        'ID_CARD_PDF_417',
        'SEPA',
        'SWISS_QR',
        'VCARD',
        'GS1',
        'HIBC',
        'BRITISH_COLUMBIA_DRIVER_LICENSE',
    ];
    /**
      Barcode types that are used to encode documents.
      */
    BarcodeDocumentFormats.documentBarcodeFormats = {
        AAMVA: ['PDF_417'],
        ID_CARD_PDF_417: ['PDF_417'],
        SEPA: ['QR_CODE'],
        MEDICAL_CERTIFICATE: ['PDF_417'],
        DE_MEDICAL_PLAN: ['DATA_MATRIX'],
        BOARDING_PASS: ['PDF_417', 'AZTEC', 'QR_CODE'],
        VCARD: ['QR_CODE', 'DATA_MATRIX'],
        SWISS_QR: ['QR_CODE'],
        GS1: [
            'CODE_128',
            'AZTEC',
            'DATA_MATRIX',
            'DATABAR',
            'DATABAR_EXPANDED',
            'DATABAR_LIMITED',
            'EAN_13',
            'EAN_8',
            'GS1_COMPOSITE',
            'ITF',
            'MICRO_PDF_417',
            'PDF_417',
            'QR_CODE',
            'UPC_A',
            'UPC_E',
        ],
        HIBC: ['CODE_39', 'CODE_128', 'AZTEC', 'DATA_MATRIX', 'MICRO_PDF_417', 'PDF_417', 'QR_CODE'],
        BRITISH_COLUMBIA_DRIVER_LICENSE: ['PDF_417'],
    };
})(BarcodeDocumentFormats || (BarcodeDocumentFormats = {}));
/**
The result of barcode document parsing.
*/
export class BarcodeDocumentParserResult {
    /** @param source {@displayType `DeepPartial<BarcodeDocumentParserResult>`} */
    constructor(source = {}) {
        this._released = false;
        if (source.success !== undefined) {
            this.success = source.success;
        }
        else {
            throw new Error('success must be present in constructor argument');
        }
        if (source.parsedDocument !== undefined) {
            this.parsedDocument = source.parsedDocument != null ? new GenericDocument(source.parsedDocument) : null;
        }
        else {
            throw new Error('parsedDocument must be present in constructor argument');
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            success: this.success,
            parsedDocument: this.parsedDocument != null ? await this.parsedDocument.serialize(config) : null,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.parsedDocument != null) {
                this.parsedDocument.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.parsedDocument != null) {
            await this.parsedDocument.encodeImages();
        }
    }
}
//# sourceMappingURL=BarcodeDocumentTypes.js.map